export function setOrderFulfillmentVersionBasic(state) {
  state.order_fulfillment_version = "basic";
}
export function setOrderFulfillmentVersionAdvanced(state) {
  state.order_fulfillment_version = "advanced";
}
export function clearOrderFulfillmentVersion(state) {
  state.order_fulfillment_version = null;
}

export function setOrderKeepsFulfillmentControls(state, show) {
  state.order_keeps_fulfillment_controls = !!show;
}
